import React from "react";
import { useLang } from "../../i18n/LanguageContext";
import { useAdminLanguage } from "../../i18n/adminTranslations";

export default function AdminLanguageSelector() {
  const { lang, setLang } = useLang();
  const { a } = useAdminLanguage();
  return (
    <label className="inline-flex flex-wrap items-center gap-2 text-sm font-semibold text-zinc-300">
      <span>{a("Language")}</span>
      <select
        data-testid="admin-language-select"
        value={lang}
        onChange={event => setLang(event.target.value)}
        className="bg-zinc-900 border border-white/20 px-3 py-2 min-h-[44px] text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400"
      >
        <option value="pt" lang="pt">PT · Português</option>
        <option value="en" lang="en">EN · English</option>
        <option value="es" lang="es">ES · Español</option>
      </select>
    </label>
  );
}
